import { render } from "./SubmitToolPage.vue?vue&type=template&id=f8ed0d1e"
import script from "./SubmitToolPage.vue?vue&type=script&lang=js"
export * from "./SubmitToolPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__